<ion-content forceOverscroll="false">
  <app-header [fixedTitle]=true>
    <app-toolbar [title]="signInfoLabel">
      <app-toolbar-button [text]="'lbl_cancel' | translate" slot="start" (click)="closeModal()"></app-toolbar-button>
    </app-toolbar>
  </app-header>

  <main [attr.data-hasFooter]="!isMobile">
    <signature-pad #signaturePad [options]="signaturePadOptions" (onBeginEvent)="signaturePadIsEmpty = false"></signature-pad>

    @if (isMobile) {
      <div class="buttons-container mobile">
        <app-button tabindex="-1" class="clear-pad" expanded (click)="clearSignPad()">{{ 'lbl_delete' | translate }}</app-button>
        <app-button tabindex="-1" [disabled]="signButtonDisabled" expanded (click)="sign()">{{ signButtonLabel | translate }}</app-button>
      </div>
    }
  </main>

  @if (!isMobile) {
    <app-footer>
      <div class="buttons-container">
        <app-button tabindex="-1" class="clear-pad" expanded (click)="clearSignPad()">{{ 'lbl_delete' | translate }}</app-button>
        <app-button tabindex="-1" [disabled]="signButtonDisabled" expanded (click)="sign()">{{ signButtonLabel | translate }}</app-button>
      </div>
    </app-footer>
  }
</ion-content>
